<template>
	<div id="reception">
		<div class="bg"></div>
		<div class="container">
			<div v-if="!successFlag && !errorFlag" class="centerblock">
				<!--
				<h6>URLあり</h6>
				<ReceptionQr></ReceptionQr>

				<h6>トークンのみ</h6>
				-->
				<ReceptionQr token="only"></ReceptionQr>
	
				<div class="qr_desc">【{{textQrDesc()}}】</div>
				
				<div class="statusbox">
					<h5>受付状況</h5>
					<p>{{statusReception}}</p>
				</div>

				<div class="cmdbox">
					<button class="btn btn-primary" @click.prevent="$emit('close-reception')">キャンセル</button>
				</div>

			</div>
			<div v-if="successFlag" class="centerblock">
				<p>ご利用ありがとうございます。</p>
				<p>ご入館ください。</p>

				<div class="cmdbox">
					<button class="btn btn-primary" @click.prevent="$emit('close-reception')">OK</button>
				</div>

			</div>
			<div v-if="errorFlag" class="centerblock">
				<p>ご利用手続きありがとうございます。</p>
				<p>下記理由によりご利用いただけません。</p>
				<p>{{statusReception}}</p>

				<div class="cmdbox">
					<button class="btn btn-primary" @click.prevent="$emit('close-reception')">OK</button>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
	import ReceptionQr from '@/components/ReceptionQr'

	export default {
		components: {
			ReceptionQr,
		},
		props: {
		},
		data () {
			return {
				tidCheckReceptionStatus: null,
				responseEntry: null,
				statusReception: '',
				
				successFlag: false,
				errorFlag: false,
			};
		},
		computed: {
			receptionToken() {
				const response = this.$store.getters['commonStore/getResponseRunstReception'];
				if(response) {
					return [{
						name:'reception_url',
						value: response.reception_url
					}];
				}
				return null;
			},
		},
		methods: {
			clearReceptionStatusTimer() {
				if(this.tidCheckReceptionStatus) {
					clearInterval(this.tidCheckReceptionStatus);
					this.tidCheckReceptionStatus = null;
				}
			},
			async receptionRunstMonth() {
				this.clearReceptionStatusTimer();
				this.statusReception = "認証中";
				const rslt = await this.$store.dispatch('commonStore/receptionRunst');
				console.log('--rslt', rslt)
				if(rslt) {
					if(rslt.name) {
						this.checkReceptionStatus();
					} else {
						this.errorFlag = true;
						this.statusReception = '有効な利用権を確認できませんでした。';
					}
				}
			},
			checkReceptionStatus() {
				this.tidCheckReceptionStatus = setInterval(async () => {
					const response = await this.$store.dispatch('commonStore/checkReceptionStatus');
					// 最初に認証中判定を行う
					if(response && response.status == 'success' && response.payload && response.payload.status == 'running') {
						return;
					}
					
					// 認証中以外は以降のチェックは不要です
					clearInterval(this.tidCheckReceptionStatus);
					this.tidCheckReceptionStatus = null;
					
					let status_text = 'システムエラー(03)';
					
					console.log(response);
					if(!response) {
						status_text = "システムエラー(01)";
						this.errorFlag = true;
					} else if(response.status == 'error') {
						status_text = response.error.msg;
						this.errorFlag = true;
					} else if(response.status == 'success') {
						const payload = response.payload;
						if(payload.status == 'succeed') {
							this.successFlag = true;
							status_text = '認証完了';	
							// チケット使用などでステータス変更の可能性があるので、再取得しておく
							this.$store.dispatch('commonStore/runstStatus');
						} else {
							this.errorFlag = true;
							status_text = "システムエラー(02)";
						}
					}
					
					this.statusReception = status_text;
				}, 1000);

			},
			textQrDesc() {
				const response = this.$store.getters['commonStore/getResponseRunstReception'];
				if(response) {
					return response.name;
				}
				return '';
			},
		},
		mounted() {
			this.receptionRunstMonth();
		},
		destroyed() {
			if(this.tidCheckReceptionStatus) {
				clearInterval(this.tidCheckReceptionStatus);
				this.tidCheckReceptionStatus = null;
			}
		}
	};
</script>

<style lang="scss" scoped>
	#reception {
		position: fixed;
		left: 0;
		top: 0;
		.bg {
			position: fixed;
			left: 0;
			top: 0;
			width: 100vw;
			height: 100vh;
			background-color: rgba(0, 0, 0, 0.25);
		}
		.container {
			position: absolute;
			left: 0;
			top: 0;
			display: flex;
			width: 100vw;
			height: 100vh;
			justify-content: center;
			align-items: center;
			.centerblock {
				padding: 8px;
				border-radius: 4px;
				background-color: #fff;
			}
			.qr_desc {
				text-align: center;
			}
			.statusbox {
				padding: 1em;
			}
			.cmdbox {
				text-align: center;
			}
			
			.wrapper {
				width: 200px;
			}
		}
	}
</style>
